<template>
    <td-dialog
        :title="$t(title)"
        @cancel="classifyDialogClose"
        :before-close="classifyDialogClose"
        :visible.sync="dialogClassifyVisible"
        width="540px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-form>
            <el-form-item :label="$t('pgCommon.ALARM_GROUP')" :label-width="formLabelWidth" prop="sAlarmTypeId" style="margin-left:205px;margin-bottom:5px">
                <td-tree-select
                    ref="TdAlarmTypeTree"
                    :treeList="alarmTypeList"
                    :lazyloading="lazyloading"
                    :defaultProps="defaultProps"
                    :isSingleCheck="isSingleCheck"
                    :inputShow="inputShow"
                    :nodeKey="nodeKey"
                    :expandAll="expandAll"
                    :multiple="false"
                    @clickSelect="changeAlarmType"
                    @handleClose="deleteAlarmType"
                ></td-tree-select>
            </el-form-item>
            <td-transfer
                v-model="classifiedData"
                :props="{ key: 'sId', label: 'sName' }"
                :titles="[$t('common.ALARM_TYPE'), $t('pgCommon.TYPE_LIST')]"
                :data="classifiedDataAll"
                @change="changeTransfer"
            ></td-transfer>
        </el-form>
    </td-dialog>
</template>
<script>
import api from '../assets/api.js';
export default {
    props: ['title', 'dialogClassifyVisible'],
    created() {
        this.initSelect();
    },
    // 定义变量
    data() {
        return {
            formLabelWidth: '31%',
            alarmTypeList: [],
            classifiedDataAll: [],
            classifiedData: [],
            defaultProps: {
                children: 'children',
                label: 'typeName',
                id: 'id'
            },
            lazyloading: false,
            isSingleCheck: true,
            inputShow: false,
            nodeKey: 'id',
            expandAll: true
        };
    },
    // 定义并实现方法体
    methods: {
        initSelect() {
            api.getAlarmTypeTree('', response => {
                this.alarmTypeList = response.data.content;
            });
            api.getAlarmEventAll(JSON.stringify({}), response => {
                this.classifiedDataAll = response.data.content;
            });
        },
        // 改变报警类型下拉框触发
        changeAlarmType(value) {
            this.classifiedData = [];
            for (let i = 0; i < this.classifiedDataAll.length; i++) {
                if (this.classifiedDataAll[i].sAlarmTypeId === value.id) {
                    this.classifiedData.push(this.classifiedDataAll[i].sId);
                }
            }
        },
        // 报警类型清空执行的方法
        deleteAlarmType() {
            this.classifiedData = [];
        },
        // 改变穿梭框触发
        changeTransfer(value, direction, moveArray) {
            let content = {};
            let alarmTypeNode = this.$refs.TdAlarmTypeTree.getSelectedNodes();
            if (direction === 'right') {
                content.sAlarmTypeId = alarmTypeNode ? alarmTypeNode.id : null;
                content.sIdArray = moveArray;
            } else {
                content.sAlarmTypeId = '';
                content.sIdArray = moveArray;
            }
            if (content.sAlarmTypeId === null) {
                this.$nextTick(function() {
                    this.classifiedData = [];
                });
                this.$message({ showClose: true, message: this.$t('pgMessage.PLEASE_CHOOSE_ALARM_GROUP'), type: 'warning' });
                return;
            }
            this.updateAlarmEventType(content);
        },
        // 修改报警事件类型
        updateAlarmEventType(content) {
            api.updateAlarmEventType(JSON.stringify(content), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('alarm/updateAlarmEventType', response.data.statusMessage);
                    this.changeAlarmType(this.alarmType);
                    return;
                }
                for (let i = 0; i < this.classifiedDataAll.length; i++) {
                    if (content.sIdArray.indexOf(this.classifiedDataAll[i].sId) > -1) {
                        this.classifiedDataAll[i].sAlarmTypeId = content.sAlarmTypeId;
                    }
                }
            });
        },
        // 关闭窗口之前需要调用的方法
        classifyDialogClose() {
            this.$emit('classifyDialogClose');
            this.$emit('submit');
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: rgb(30, 160, 255);
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
